/**
 * 
 * Markdown ready convers MarkDown to real value html
 * Custom Built by Sam Ayoub - EC APIC4E
 * 
 * Cards Example can be changes from here the way it's needed
 * #cards# 
  *
  *<!-- card 1 -->
  * #card# 
  * #card-header# testing card header #card-header#
  * #card-body# testing card body #card-body#
  * #card#
  *
  *<!-- card 2 -->
  *
   * #card# 
  * #card-header# testing card header #card-header#
  * #card-body# testing card body #card-body#
  * #card#
  *
  *<!-- card 3 -->
  *
  * #card# 
  * #card-header# testing card header #card-header#
  * #card-body# testing card body #card-body#
  * #card#
  * 
  * #cards# 
  * 
  * // end of cards
  *
 */

const mdRegex = {
    title: /^#\s+.+/,
    heading: /^#+\s+.+/,
    custom: /\$\$\s*\w+/,
    ol: /\d+\.\s+.*/,
    ul: /\*\s+.*/,
    task: /\*\s+\[.]\s+.*/,
    blockQuote: />.*/,
    table: /|.*/,
    image: /!\[.+\]\(.+\).*/,
    url: /\[.+\]\(.+\).*/,
    codeBlock: /`{3}\w+.*/,
    // cards:  /\#cards\#.+?\#\/cards\#/g, // match all the items between cards example
    // card:  /\#card\#.+?\#\/card\#/g, // match all the items between cards example
  };
  
  const isTitle = (str) => mdRegex.title.test(str);
  const isHeading = (str) => mdRegex.heading.test(str);
  const isCustom = (str) => mdRegex.custom.test(str);
  const isOl = (str) => mdRegex.ol.test(str);
  const isUl = (str) => mdRegex.ul.test(str);
  const isTask = (str) => mdRegex.task.test(str);
  const isBlockQuote = (str) => mdRegex.blockQuote.test(str);
  const isImage = (str) => mdRegex.image.test(str);
  const isUrl = (str) => mdRegex.url.test(str);
  const isCodeBlock = (str) => mdRegex.codeBlock.test(str);
  // const isCards = (str) => mdRegex.cards.test(str); // use match to find all, or test to check if exist at least one
  // const isCard = (str) => mdRegex.card.test(str); // use match to find all, or test to check if exist at least one
  
  /**
   * getMdTitle
   * @param {string} md 
   * @returns 
   */
function getMdTitle(md) {
    let titles = [];
    let result = md.split("\n");
    for (let i = 0; i < result.length; i++) {
      if (isHeading(result[i]) || isTitle(result[i])) {
            // titles.toString().match(/(?<=\[).+?(?=\])/g) # Another option is to use MD ways
            titles.push(result[i].replaceAll('#', '').replaceAll('*', '').trimStart());
        }
    }
    return titles;
  }
/**
 * getMdDescription
 * @param {string} md 
 * @returns 
 */
function getMdDescription(md) {
    let result = md.split("\n");
    let array = [];
    for (let i = 0; i < result.length; i++) {
      if (
        isCustom(result[i]) ||
        isOl(result[i]) ||
        isUl(result[i]) ||
        isTask(result[i]) ||
        isBlockQuote(result[i]) ||
        isImage(result[i]) ||
        isUrl(result[i]) ||
        isCodeBlock(result[i])
      )  
      array.push(result[i].trimStart());
    }
    return array;
  }
/**
 * getMdHeaders
 * @param {string} md 
 * @returns 
 */
function getMdHeaders(md) {
let titles = [];
let result = md.split("\n");
for (let i = 0; i < result.length; i++) {
    if (isHeading(result[i]) || isTitle(result[i])) {
        titles.push(result[i]);
    }
}
return titles;
}
  
export {
    getMdDescription,
    getMdTitle,
    mdRegex,
    getMdHeaders
}